import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { SamwinSkillTypeEnum } from 'src/app/store/samwin/samwin-skills/samwin-skills-type-enum';
import { SkillGroup } from 'src/app/store/samwin/samwin-skills/skill-group';

@Pipe({
   name: 'mailingSkills',
})
export class MailingSkillsPipe implements PipeTransform {
   constructor() {}

   transform(skills: SkillGroup[]): SkillGroup[] {
      return _(skills)
         .filter((s) => s.skillConfiguration.skillType === SamwinSkillTypeEnum.MAILING.value)
         .value();
   }
}
